import type { IFrameOutgoingPostFunction } from '@/types'

export const emitToParent: IFrameOutgoingPostFunction = (eventType, payload) => {
	window.parent.postMessage(
		{
			type: eventType,
			payload
		},
		'*'
	)
}
